function normalizeText(value) {
  return String(value ?? '').trim()
}

function isNumericText(value) {
  return /^\d+$/.test(normalizeText(value))
}

export function resolveStudentRecordId(item = {}) {
  return normalizeText(item.studentId ?? item.student_id ?? item.id)
}

export function resolveStudentAccountId(item = {}) {
  return normalizeText(item.accountUserId ?? item.userId ?? item.user_id)
}

export function resolveStudentEvaluationTargetId(item = {}) {
  const accountId = resolveStudentAccountId(item)
  const studentId = resolveStudentRecordId(item)

  if (isNumericText(accountId)) return accountId
  if (!studentId) return accountId
  return studentId || accountId
}

export function resolveStudentPhotoFile(item = {}) {
  return item.photo_file
    ?? item.photoFile
    ?? item.student_photo
    ?? item.studentPhoto
    ?? item.avatar_url
    ?? item.avatarUrl
    ?? item.image_url
    ?? item.imageUrl
    ?? ''
}

function normalizeStudentProfile(item = {}) {
  return {
    id: resolveStudentRecordId(item),
    userId: resolveStudentAccountId(item) || null,
    name: item.student_name ?? item.name ?? '',
    studentNo: item.student_number ?? item.studentNo ?? '',
    phone: item.student_phone ?? item.phone ?? '',
    classId: item.class_id ?? item.classId ?? null,
    className: item.class_name ?? item.className ?? '',
    photoFile: resolveStudentPhotoFile(item)
  }
}

export function extractStudentProfileList(payload = {}) {
  const data = payload?.data ?? payload ?? {}
  if (Array.isArray(data)) return data
  if (Array.isArray(data.records)) return data.records
  if (Array.isArray(data.list)) return data.list
  if (Array.isArray(data.items)) return data.items
  if (Array.isArray(payload?.list)) return payload.list
  return []
}

function collectStudentProfileKeys(item = {}) {
  const keys = []
  const userId = item.userId ?? item.user_id
  const id = item.id ?? item.student_id
  const studentNo = item.studentNo ?? item.student_number
  const name = item.name ?? item.student_name

  if (userId !== undefined && userId !== null && userId !== '') {
    keys.push(`user:${normalizeText(userId)}`)
  }
  if (id !== undefined && id !== null && id !== '') {
    keys.push(`id:${normalizeText(id)}`)
  }
  if (normalizeText(studentNo)) {
    keys.push(`no:${normalizeText(studentNo)}`)
  }
  if (normalizeText(name)) {
    keys.push(`name:${normalizeText(name)}`)
  }
  return keys
}

export function buildStudentProfileLookup(list = []) {
  const lookup = new Map()
  list
    .map(item => normalizeStudentProfile(item))
    .forEach((item) => {
      collectStudentProfileKeys(item).forEach((key) => {
        if (!lookup.has(key)) lookup.set(key, item)
      })
    })
  return lookup
}

export function findStudentProfile(lookup, ...sources) {
  if (!(lookup instanceof Map) || !lookup.size) return null
  for (const source of sources) {
    const keys = collectStudentProfileKeys(source)
    for (const key of keys) {
      if (lookup.has(key)) return lookup.get(key)
    }
  }
  return null
}
